import { TyInput } from '../TyInput';
import { ComponentProps } from 'react';
import { timeFormatter } from '../utils';
import { useFieldApi, useFieldState } from 'informed';

type TyTimeInputProps = Omit<ComponentProps<typeof TyInput>, 'formatter'>;

export const TyTimeInput = (props: TyTimeInputProps) => {
  const { value } = useFieldState<string|number>(props.name);
  const { setValue } = useFieldApi(props.name);
  const formatTime = () => {
    if (!value) {
      return;
    }
    const [hours = '00', minutes = '00'] = String(value).split(':');

    setValue(`${hours}:${minutes}`);
  }
  return <TyInput {...props} formatter={timeFormatter} onBlur={formatTime} />;
};
